import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";

export const useSubmitSession = () => {
  const handleErrors = useQueryErrorHandling();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.post(`onboarding/session/me/submit`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingQKeys.session() });
    },
    onError: (res: any) => {
      console.error("[From Submit Session]", res);
      handleErrors(res, "mutation");
    },
  });
};
